import ProductAddToCart from './ProductAddToCart';

const ProductCard = ({ product, hideControls = false }) => {
  const parsedPrice = Number(product?.price);
  const displayPrice = Number.isFinite(parsedPrice)
    ? parsedPrice.toFixed(2)
    : '0.00';

  return (
    <div className="h-full">
      <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow h-full flex flex-col">
        <div className="aspect-[4/3] relative">
          <img
            src={product.image || '/images/products-logo.jpg'}
            alt={product.name}
            className="w-full h-full object-cover"
          />
          {!product.inStock && (
            <div className="absolute top-2 right-2 bg-red-500 text-white px-2 py-1 rounded text-sm">
              Out of Stock
            </div>
          )}
        </div>
        <div className="p-4 flex flex-col flex-grow">
          <h3 className="text-lg font-medium text-gray-900 mb-2 line-clamp-2 min-h-[3.5rem]">
            {product.name}
          </h3>
          <p className="text-gray-500 text-sm mb-4 line-clamp-2">
            {product.description}
          </p>
          <div className="mt-auto flex justify-between items-center">
            <p className="text-primary-600 font-semibold">
              Rs. {displayPrice}
            </p>
            {!hideControls && <ProductAddToCart product={product} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
